import { crmAuthHttp } from '@/api/crm-auth'

// 每次開啟都換一張新的一次性通行證（60 秒）；只送 app，身分由 CRM JWT 決定，不帶舊版參數。
export async function requestCrmToolLaunchUrl(app) {
  const { data } = await crmAuthHttp.post('/api/external-auth/tool-ticket', { app }, { timeout: 10000 })
  const launchUrl = data && data.launch_url
  // 空白分頁與 CRM 同源，只接受帶通行證的 https 網址，避免 javascript: 等網址在 CRM 身分下執行。
  const url = new URL(typeof launchUrl === 'string' ? launchUrl : '')
  if (url.protocol !== 'https:' || !/^#ticket=./.test(url.hash)) throw new Error('工具啟動網址格式不符')
  return launchUrl
}

// 只回固定文案，不顯示後端或 axios 的原始錯誤內容。
export function crmToolLaunchError(error) {
  const status = error && error.response && error.response.status
  if (status === 401) return 'CRM 登入已失效，請重新登入後再開啟'
  if (status === 422) return '此工具目前尚未開放，請聯絡 DentCo 客服'
  if (status === 503) return '工具登入服務暫時無法使用，請稍後再試'
  return '無法開啟工具，請確認網路連線後再試'
}
